// import PersonIcon from "@material-ui/icons/Person";
import TextField from "@material-ui/core/TextField";

const TextFieldUser = ({childIu,stateHelper,stateDiss,onChangeUser,onKeypressUser}) => {
	return (
		<>
			{/* <PersonIcon color="primary" /> */}
			<TextField
				name="Usuario"
				inputRef={childIu}
				error={stateHelper.eiu}
				disabled={stateDiss.diu}
				autoFocus
				helperText={stateHelper.tiu}
				onChange={onChangeUser}
				onKeyPress={onKeypressUser}
				label="Usuario"
				style={{ width: "100%" }}
				variant="filled"
			/>
		</>
	);
};
export default TextFieldUser;